import React, {useState} from "react"
import Widget from "../../components/widget";
import Datatable from "../../components/datatable";
import {Button} from "../../components/My/Button";
import {EnigooLoader} from "../../components/My/EnigooLoader";
import moment from "moment/moment";
import ArenaExternTicketsModal from "./ArenaExternTicketsModal";
import ApproveModal from "./Modal/ApproveModal";
import {apiGetEventCodes, apiGetEventListEntrances, apiImportEventToTurnstile} from "./Actions";
import Toast from "cogo-toast";
import FileDownload from "js-file-download";

const TableData = ({data, loading, subjectId, close}) => {

    let [arenaExternTicketsModal, setArenaExternTicketsModal] = useState(null)
    let [importTicketToTurnstile, setImportTicketToTurnstile] = useState(false)
    let [downloadEventCodesButton, setDownloadEventCodesButton] = useState(false)
    let [downloadEventEntrancesButton, setDownloadEventEntrancesButton] = useState(false)

    if (loading) return <EnigooLoader/>
    if (!data) return null


    const importTicket = () => {

        apiImportEventToTurnstile(subjectId, importTicketToTurnstile?.id, (data) => {

        }, error => {

        })
        Toast.success("Import probíhá napozadí.")
        setImportTicketToTurnstile(null)

    }

    const downloadEventCodes = (eventId) => {
        apiGetEventCodes(eventId,(response) => {
            let blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            FileDownload(blob, response.headers['content-disposition'].replace('attachment; filename=', ''))
            setDownloadEventCodesButton(false)
        }, error => {
            Toast.warn(error?.message)
            setDownloadEventCodesButton(false)
        })
    }

    const downloadEventEntrances = (eventId) => {

        apiGetEventListEntrances(eventId,(response) => {
            let blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            FileDownload(blob, response.headers['content-disposition'].replace('attachment; filename=', ''))
            setDownloadEventEntrancesButton(false)
        }, error => {
            Toast.warn(error?.message)
            setDownloadEventEntrancesButton(false)
        })
    }

    const onClose = () => {
        setArenaExternTicketsModal(null)
        close()
    }


    let columns = [
            {Header: 'Název události', accessor: "name"},
            {
                Header: 'Datum události', accessor: d => (
                    <span>{moment(d.startTime).format("DD.MM.YYYY")}</span>

                )
            },
            {
                Header: 'Vstupenek/importováno', accessor: d => (
                    <span>{d.ticketCount ? d.ticketCount : 0}/{d.importedCount ? d.importedCount : 0}</span>

                )
            },
            {Header: 'Počet průchodů', accessor: "entranceCount"},
            {
                Header: 'Stažení', accessor: d => (
                    <Button text={"Stáhnout nahrané"} loading={downloadEventCodesButton} onClick={() => {
                        downloadEventCodes(d.id)
                        setDownloadEventCodesButton(true)
                    }}/>
                )
            },
            {
                Header: 'Vložit externí vstupenky', accessor: d => (
                    <Button text={"Vložit"} onClick={() => {
                        setArenaExternTicketsModal(d)
                    }}/>
                )
            },
            {
                Header: 'Importovat',
                accessor: d => (
                    <Button text={"Spustit import do turniketů"} onClick={() => setImportTicketToTurnstile(d)}/>)
            },
            {
                Header: 'Možnosti', accessor: d => (
                    <Button text={"Stážení průchodů"} onClick={() => {
                        downloadEventEntrances(d.id)
                        setDownloadEventEntrancesButton(true)
                    }}
                    loading={downloadEventEntrancesButton}/>
                )
            }
        ]
    ;

    const getBodyModal = () => {
        return(
            <div>
                <div className={"text-base"}>Opravdu chcete nahrát událost?</div>
                <h4 className={"text-base justify-center"}>Událost: {importTicketToTurnstile?.name}</h4>
            </div>
        )
    }


    return (
        <>
            <Widget>
                <Datatable data={data} columns={columns}/>
            </Widget>
            <ArenaExternTicketsModal
                visible={!!arenaExternTicketsModal}
                event={arenaExternTicketsModal}
                close={() => onClose()}
            />

            <ApproveModal visible={!!importTicketToTurnstile}
                          close={() => setImportTicketToTurnstile(null)}
                          accept={() => importTicket()}
                          text={getBodyModal()}/>

        </>

    )
}

export default TableData
